































































import { Vue, Prop, Component } from "vue-property-decorator";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import { LaborExportClass } from "@/services/LaborExportClass";
import {
  Export as IExport,
  ExportStatusEnum
} from "@/api-v2/import-export-2/models/export";

@Component({
  components: { CustomTableCol, CustomTableItem, CustomTable }
})
export default class ExportTable extends Vue {
  @Prop({ default: () => [] }) items?: IExport[];
  @Prop() isLoading!: boolean;

  getStatus(status: ExportStatusEnum) {
    return LaborExportClass.getExportStatus(status);
  }
}
